import React, {createContext, useReducer} from "react";

import {DWPUploadReducer} from "../reducers/DWPUploadReducer";

export const DWPFileContext = createContext();

const DWPFileContextProvider = (props) => {
    const state = {
        fileName: '',
        creationTime: '',
        uploadSource: undefined
    }
    const [ viewModelDWP, dispatchDWP ] = useReducer(DWPUploadReducer, state);
    return (
        <DWPFileContext.Provider value = {{viewModelDWP, dispatchDWP}}>
            {props.children}
        </DWPFileContext.Provider>
    )
}

export default DWPFileContextProvider


// WEBPACK FOOTER //
// ./src/components/fileupload/context/DWPUploadContext.js